import decodeJWT from "jwt-decode";
import moment from "moment";

/**
 * Function for getting the filename
 * @param name String attachment/file's name
 */
export const getFileName = (name: string) => {
  const typeTokens = name.split(".");
  if (typeTokens.length > 2) {
    let filename = "";
    for (let i = 0; i < typeTokens.length - 1; i++) {
      filename = filename ? `${filename}.${typeTokens[i]}` : typeTokens[i];
    }
    return filename;
  } else {
    return typeTokens[typeTokens.length - 2];
  }
};

/**
 * Function for getting the file's type
 * @param name String attachment/file's name
 */
export const getFileType = (name: string) => {
  const typeTokens = name.split(".");
  return typeTokens[typeTokens.length - 1];
};

// Capitalize the first letter of a string
export const capitalizeString = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

// export const getLoggedInUserName = () => {
//   const userToken = localStorage.getItem("msal.idtoken");
//   const userDetails = getCurrentUser(userToken);

//   let username = "";
//   if (userDetails.name) {
//     username = userDetails.name;
//   } else {
//     if (userDetails.firstName) {
//       username = userDetails.firstName;
//     }

//     if (userDetails.lastName) {
//       username = username
//         ? `${username} ${userDetails.lastName}`
//         : userDetails.lastName;
//     }
//   }

//   if (!username) {
//     if (userDetails.emails.length) {
//       username = getStringBeforeSubstring(userDetails.emails[0], "@");
//     } else {
//       username = "Unkown";
//     }
//   }
//   return username;
// };

/**
 * Function for getting the document's height
 */
export const getDocHeight = () => {
  const documentHeight = document.body.scrollHeight;
  const windowHeight = window.outerHeight;
  if (documentHeight > windowHeight) {
    return documentHeight * 2.65;
  } else {
    return windowHeight * 2.65;
  }
};

export const base64ToArrayBuffer = (base64: any) => {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};

export const getStringAfterSubstring = (
  parentString: string,
  substring: string
) => {
  return parentString.substring(
    parentString.indexOf(substring) + substring.length
  );
};

export const getStringBeforeSubstring = (
  parentString: string,
  substring: string
) => {
  return parentString.substring(0, parentString.indexOf(substring));
};

export const getCurrentUser = (token: any) => {
  const decoded: any = decodeJWT(token);  
  let email = "";
  if (decoded.email) {
    email = decoded.email;
  } else if (decoded.emails) {
    email = decoded.emails;
  } else if (decoded["signInNames.emailAddress"]) {
    email = decoded["signInNames.emailAddress"];
  }
  return {
    name: (decoded as any).name,
    firstName: (decoded as any).given_name,
    lastName: (decoded as any).family_name,
    emails: email,
    city: (decoded as any).city,
    country: (decoded as any).country,
  };
};

export const getLoggedInCurrentUserDetails = (loggedInUser: any) => {
  let name, firstName, lastName, email = "";

  if (loggedInUser) {    
    let stringArray = loggedInUser.userName.split(":");
    if (stringArray && stringArray.length) {
      email = stringArray[1] ? stringArray[1].trim() : stringArray[1];
      let userNames = stringArray[0].split(" ");
      if (userNames && userNames.length) {
        name = stringArray[0];
        firstName = userNames[0];
        lastName = userNames[1];
      }
    }
  }

  return {
    name: name,
    firstName: firstName,
    lastName: lastName,
    emails: email,
    //city: "TestCity",
    //country: "TestCountry",
  };
};

export const emptyDate = (value: any) => {
  const newValue = value.split("T")[0];
  if (newValue) {
    return value;
  } else {
    return null;
  }
};

/**
 * Function returning the build date(as per provided epoc)
 * @param epoc Time in milliseconds
 */
export const getBuildDate = (epoc: any) => {
  const buildDate = new Date(epoc);
  return `${formatDate(buildDate.getDate())}-${formatDate(
    buildDate.getMonth() + 1
  )}-${buildDate.getFullYear()} ${formatDate(
    buildDate.getHours()
  )}:${formatDate(buildDate.getMinutes())}`;
};

/**
 * Function returning month in desired format
 * @param val Number Month in numeric type
 */
const formatDate = (val: any) => {
  if (val < 10) {
    return `0${val}`;
  } else {
    return val;
  }
};

/**
 * Function for converting moment date to local date
 * @param date Date
 */
export const getLocalDateFromMoment = (date: any) => {
  if (date) {
    return moment(date).format("YYYY-MM-DD");
  } else {
    return moment().format("YYYY-MM-DD");
  }
};

export const sortObjectDataByAsending = (data: any, field: any) => {
  if (data && data.length) {
    data.sort(function (a: any, b: any) {
      var nameA = a[field].toLowerCase(),
        nameB = b[field].toLowerCase();
      if (nameA < nameB)
        //sort string ascending
        return -1;
      if (nameA > nameB) return 1;
      return 0; //default return value (no sorting)
    });
  }
  return data;
};

export const getDuplicateArrayElements = (arr: any): [] => {
  var sorted_arr = arr.slice().sort();
  var results: any = [];
  for (var i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1] === sorted_arr[i]) {
      results.push(sorted_arr[i]);
    }
  }
  return results;
};

export const getLocalDateFromUTC = (date: any) => {
  if (date) {
    const updatedDate = moment.utc(date).local().format("DD-MMM-YYYY");
    return updatedDate;
  } else {
    return null;
  }
};